import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// GA4 SPA route tracking.
// gtag.js (index.html) auto-sends the FIRST page_view on load, so here we skip
// the initial render and only send page_view on subsequent route changes.
// This guarantees pageviews are recorded even if this component ever fails.
const Analytics = () => {
  const location = useLocation();
  const firstLoad = useRef(true);

  useEffect(() => {
    if (firstLoad.current) {
      firstLoad.current = false;
      return;
    }
    if (typeof window.gtag !== "function") return;
    const id = window.setTimeout(() => {
      window.gtag("event", "page_view", {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
        page_title: document.title,
      });
    }, 0);
    return () => window.clearTimeout(id);
  }, [location.pathname, location.search]);

  return null;
};

export default Analytics;
